import { Component, inject, OnDestroy, ViewChild } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { EmailDialogComponent } from '../email-dialog/email-dialog.component';
import { ReCaptchaV3Service } from 'ng-recaptcha-2';
import { Subject, takeUntil } from 'rxjs';
import { ErrorConstants } from '../../constants/error_constants';
import { LeadApi } from '../../api/leadApi';

@Component({
  selector: 'app-sponsor-dialog',
  standalone: false,
  templateUrl: './sponsor-dialog.component.html',
  styleUrl: './sponsor-dialog.component.scss',

})
export class SponsorDialogComponent implements OnDestroy {

  readonly dialogRef = inject(MatDialogRef<SponsorDialogComponent>);
  readonly dialog = inject(MatDialog);
  readonly data = inject(MAT_DIALOG_DATA);

  constructor(
    private clipboard: Clipboard,
    private recaptchaV3Service: ReCaptchaV3Service,
    private leadApi: LeadApi,
  ) {

  }

  @ViewChild('tooltip') tooltip!: MatTooltip;
  @ViewChild('emailTooltip') emailTooltip!: MatTooltip;

  destroy$: Subject<boolean> = new Subject<boolean>();

  private isCopyLinkClicked = false;
  private isSendEmailClicked = false;

  sendEmail() {
    this.isSendEmailClicked = true;

    try {
      this.recaptchaV3Service.execute('UpdatingLead')
        .pipe(takeUntil(this.destroy$))
        .subscribe((token: any) => {
          this.leadApi.sendAbsaLinkEmail(this.data.lead, this.data.redirectUrl).subscribe(response => {
            const leadData = {
              ...this.data.lead,
              redirected_to_share_link: this.isSendEmailClicked,
              redirected_to_copy_link: this.isCopyLinkClicked,
              recaptcha_token: token,
              openSponsorDialog: true
            }
            this.leadApi.updateLead(leadData, this.data.lead.identifier).subscribe(response => {
            });
            this.openEmailDialog(this.data.lead.applicant.email, this.data.lead.applicant.first_name + ' ' + this.data.lead.applicant.last_name);


          });

        });
    } catch (error) {
      console.error('Error sending email', error);
      this.openErrorDialog('Error sending email', 'An error sending email occurred. Please try again later.', ErrorConstants.UPDATE_LEAD);
    }

  }

  copyToClipboard() {
    this.clipboard.copy(this.data.redirectUrl);
    this.tooltip.show();
    this.isCopyLinkClicked = true;

    this.recaptchaV3Service.execute('UpdatingLead')
      .pipe(takeUntil(this.destroy$))
      .subscribe((token: any) => {
        const leadData = {
          ...this.data.lead,
          redirected_to_share_link: this.isSendEmailClicked,
          redirected_to_copy_link: this.isCopyLinkClicked,
          recaptcha_token: token,
          openSponsorDialog: true
        }
        this.leadApi.updateLead(leadData, this.data.lead.identifier).subscribe(response => {
          this.close()
        });
      });
  }

  close() {
    Promise.resolve().then(() => this.dialogRef.close('closed'));

  }

  openErrorDialog(title: string, message: string, errorCode: string) {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      data: {
        title,
        message,
        errorCode
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  openEmailDialog(sponsor_email: string, sponsor_name: string) {
    const dialogRef = this.dialog.open(EmailDialogComponent, {
      data: {
        email: sponsor_email,
        name: sponsor_name
      }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
